const testimonials = [
  {
    text: 'Road Tech came to my house and fixed my mower the same day. So convenient and professional — highly recommend!',
    name: 'Sarah L.',
    role: 'Homeowner',
    rating: 5,
  },
  {
    text: "Matt repaired my snow blower right in my driveway. Saved me so much hassle — I'll definitely use Road Tech again.",
    name: 'James P.',
    role: 'Customer',
    rating: 5,
  },
  {
    text: 'Road Tech Services saved me so much time! Instead of hauling my mower to a shop, they came right to my house and fixed it the same day. Highly recommended.',
    name: 'Mark R.',
    role: 'Homeowner',
    rating: 5,
  },
  {
    text: "Fantastic service — my snow blower was up and running within an hour of arrival. Professional, knowledgeable, and very convenient.",
    name: 'Lisa M.',
    role: 'Michigan Resident',
    rating: 5,
  },
];

export default function TestimonialsSection() {
  return (
    <section className="bg-white py-24 lg:py-32">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-14">
          <p className="text-orange-600 text-xs font-bold uppercase tracking-widest mb-3">
            Customer Reviews
          </p>
          <h2 className="font-display text-4xl lg:text-5xl font-bold uppercase tracking-tight text-neutral-900 mb-4">
            What Customers Say
          </h2>
          <p className="text-neutral-500 text-base max-w-xl mx-auto leading-relaxed">
            Road Tech Services is proud to serve Michigan homeowners with fast,
            professional, and on-site equipment repair.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-stone-50 rounded-xl p-6 flex flex-col border border-stone-100 hover:border-orange-200 transition-colors"
            >
              <div className="flex gap-0.5 mb-4">
                {Array.from({ length: t.rating }).map((_, si) => (
                  <i key={si} className="ri-star-fill text-amber-400 text-sm" />
                ))}
              </div>
              <p className="text-neutral-600 text-sm leading-relaxed flex-1 mb-5 italic">
                &ldquo;{t.text}&rdquo;
              </p>
              <div>
                <div className="font-semibold text-neutral-900 text-sm">
                  {t.name}
                </div>
                <div className="text-neutral-400 text-xs mt-0.5">{t.role}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
